import { render } from "./ConnectedAccountsPage.vue?vue&type=template&id=4d117510&ts=true"
import script from "./ConnectedAccountsPage.vue?vue&type=script&lang=ts"
export * from "./ConnectedAccountsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__